import { render } from "./FeatureSection.vue?vue&type=template&id=c4e29070&scoped=true"
import script from "./FeatureSection.vue?vue&type=script&lang=js"
export * from "./FeatureSection.vue?vue&type=script&lang=js"

import "./FeatureSection.vue?vue&type=style&index=0&id=c4e29070&scoped=true&lang=css"

import exportComponent from "/Users/tavishi/Desktop/Tilly/code/tern-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4e29070"]])

export default __exports__